const func = ($target) => {
	console.log("select all loaded");

	var $selectAll = $target.find('[data-id="select-all"]'),
		$checkboxes = $target.find("input:checkbox");

	$selectAll.change(function () {
		if ($(this).is(":checked")) {
			$checkboxes.prop("checked", true);
		} else {
			$checkboxes.prop("checked", false);
		}
	});
};

export default func;
